import { AxiosInstance } from '../../utilities/requestClient';
import { getFundsRoute } from '../../routes/endpoints/general.routes';
import type { RSPageFund } from '../api.types';
import { GetFundsParams } from './types';

/**
 * Get funds data
 * @param params - Query parameters including fundTypes, rsResources, and raptorPlatformId
 * @returns Promise<RSPageFund[]>
 */
export const getFunds = async (
  params: GetFundsParams,
): Promise<RSPageFund[]> => {
  const { fundTypes, rsResources, raptorPlatformId } = params;

  const route = getFundsRoute(fundTypes, rsResources, raptorPlatformId);

  return (await AxiosInstance.get<RSPageFund[]>(`/${route}`)).data;
};
